import Swiper from 'swiper';

export default function() {
  (function($, window) {
    const mapSwiperSelector = '.map-swiper';
    const haveMapSwiper = document.querySelectorAll(mapSwiperSelector).length > 0;
    if (haveMapSwiper) {
      // Map Component
      let currentIndexCircleWrapper = 0;
      let currentBlockIndexCircleWrapper = 0;
      let animationCirclesIntervals = [];
      // eslint-disable-next-line no-unused-vars
      const CirclesAnimationEndEvent = new Event('CirclesAnimationEnd');
      let mapSwiper = new Swiper('.map-swiper', {
        slidesPerView: 'auto',
        spaceBetween: 15,
        breakpoints: {
          700: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          992: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          1440: {
            slidesPerView: 2,
            spaceBetween: 28,
          },
          1920: {
            slidesPerView: 2,
            spaceBetween: 28,
          },
        },
      });
      function animateCircles(blockIndex, animationTimeout) {
        clearAllCircleIntervals(1000);
        window.CircleIntervals = animationCirclesIntervals;
        currentIndexCircleWrapper = 0;
        currentBlockIndexCircleWrapper = blockIndex;
        let newIntervalCircles = setInterval(function () {
          animateCircle();
        }, animationTimeout);
        animationCirclesIntervals.push(newIntervalCircles);
      }
      function clearAllCircleIntervals(cleanAllGlobal = false) {
        for (let i = 0; i < animationCirclesIntervals.length; i++) {
          clearInterval(animationCirclesIntervals[i]);
        }
        // Use cleanAllGlobal for force remove all posible intervals and avoid possible mistakes on animation changes
        if (cleanAllGlobal) {
          for (let i = 0; i < cleanAllGlobal; i++) {
            clearInterval(cleanAllGlobal);
          }
        }
        animationCirclesIntervals = [];
      }
      function animateCircle() {
        const maxIndex = $('.circle-wrapper[data-block-index=' + currentBlockIndexCircleWrapper + ']').length;
        $('.circle-wrapper[data-block-index][data-index]').removeClass('active');
        toggleGreenZone();
        const elementSelector = '.circle-wrapper[data-block-index=' + currentBlockIndexCircleWrapper + '][data-index=' + currentIndexCircleWrapper + ']';
        const imgSvg = $(elementSelector).data('circle-svg-path');
        $(elementSelector).find('img').remove(); // Remove if find img
        $(elementSelector).append('<img src="' + imgSvg + '?hash=' + Math.random() + '" alt="Animated Circle Point">');
        $(elementSelector).addClass('active');
        currentIndexCircleWrapper++;
        if (currentIndexCircleWrapper > maxIndex) {
          currentIndexCircleWrapper = 0;
          if (maxIndex > 1) $('.map-swiper').trigger('CirclesAnimationEnd');
        }
      }
      function toggleGreenZone() {
        $('.map-image-wrapper svg g path').css('fill', 'initial'); // Reset fill of green zones
        const countryGroups = $(mapSwiper.el).find('.swiper-slide:eq(' + currentBlockIndexCircleWrapper + ')').data('green-zones');
        let greenZoneForChange = false;
        if (countryGroups) {
          for (let i = 0; i < countryGroups.length; i++) {
            if (i === currentIndexCircleWrapper) {
              greenZoneForChange = countryGroups[i];
            }
          }
        }
        $('.map-image-wrapper svg g#' + greenZoneForChange + ' path').css('fill', '#79A52B');
      }
      $('.map-pagination .total-slides').text(mapSwiper.slides.length - 1);
      function mapSwiperEvents() {
        mapSwiper.on('activeIndexChange', function (swiper) {
          $('.map-pagination .bold-pagination').text(swiper.activeIndex + 1);
          $('.circle-wrapper[data-block-index][data-index]').removeClass('active');
          if ($('.circle-wrapper[data-block-index=' + swiper.activeIndex + ']').length > 1) {
            currentBlockIndexCircleWrapper = swiper.activeIndex;
            animateCircles(swiper.activeIndex, 3000);
          } else {
            currentBlockIndexCircleWrapper = swiper.activeIndex;
            clearAllCircleIntervals();
            window.CircleIntervals = animationCirclesIntervals;
            currentIndexCircleWrapper = 0;
            animateCircle();
          }
        });
        $(mapSwiperSelector).on('CirclesAnimationEnd', function () {
          mapSwiper.slideNext();
        });
      }
      mapSwiperEvents();
      $('section.map .slide-direction .go-next').on('click', function (e) {
        e.preventDefault();
        mapSwiper.slideNext();
      });
      $('section.map .slide-direction .go-prev').on('click', function (e) {
        e.preventDefault();
        mapSwiper.slidePrev();
      });
      $('section.sustainability-gestion-map .slide-direction .go-next').on('click', function (e) {
        e.preventDefault();
        mapSwiper.slideNext();
      });
      $('section.sustainability-gestion-map .slide-direction .go-prev').on('click', function (e) {
        e.preventDefault();
        mapSwiper.slidePrev();
      });
      // Add the positions to Circles
      $('.circle-wrapper').each(function () {
        $(this).css('top', $(this).data('cord-y') + '%').css('left', $(this).data('cord-x') + '%');
      });
      // Progressive animation for Circles
      animateCircle();
      if ($('.circle-wrapper[data-block-index=' + currentBlockIndexCircleWrapper + ']').length > 1) {
        animateCircles(0, 3000);
      }
      // Remove all hidden swiper (the hidden slide is for working desktop last slide) on mobile
      if (window.window.innerWidth < 600) {
        $('.swiper-wrapper .swiper-slide.hidden').remove();
        const mapSwipers = document.querySelectorAll('.map-swiper');
        mapSwipers.forEach(function(el, index){
          el.swiper.destroy(false, false);
          el.swiper.init(el);
        });
        mapSwiperEvents();
      }
    }
  })(jQuery, window);
}
